import { api } from '@/utils/api';
import { sanitizePathParam } from '@/utils/sanitize';

export default class OrganizationRepository {
  async getOrganizations({ name }: { name: null | string }) {
    const res = await api.get(`security/organizations`, { params: { name } });
    return res.data;
  }

  async getOrganizationsSettings(id: number | string) {
    const sid = sanitizePathParam(id);
    const res = await api.get(`organizations/${sid}/settings`);
    return res.data.reduce((acc, item) => {
      const settingsObj = Array.isArray(item.settings)
        ? item.settings.reduce((o, { key, value }) => {
            o[key] = value;
            return o;
          }, {})
        : {};

      acc[item.groupKey] = { settings: settingsObj };
      return acc;
    }, {});
  }

  async postOrganization(data: any) {
    const res = await api.post('security/organizations', data);
    return res.data;
  }

  async putOrganization(organizationId: string, data: any) {
    const oid = sanitizePathParam(organizationId);
    const res = await api.put(`security/organizations/${oid}`, data);
    return res.data;
  }

  async deleteOrganization(organizationId: string) {
    const oid = sanitizePathParam(organizationId);
    const res = await api.delete(`security/organizations/${oid}`);
    return res.data;
  }
}
